export function submitConstructorStartForm(startData, doc = document) {
  const startUrl = String(startData?.startUrl || '').trim();
  const fields = startData?.fields && typeof startData.fields === 'object' ? startData.fields : {};
  if (!startUrl) {
    throw new Error('Constructor start redirect is missing startUrl');
  }
  const token = fields.token;
  if (!token) {
    throw new Error('Constructor start redirect is missing form token');
  }

  const form = doc.createElement('form');
  form.method = 'POST';
  form.action = startUrl;
  form.style.display = 'none';

  Object.entries(fields).forEach(([name, value]) => {
    const input = doc.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value ?? '');
    form.appendChild(input);
  });

  doc.body.appendChild(form);
  form.submit();
  return form;
}
